import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RolesPermissionsService } from '../service/catalogs/rolesPermissions/roles-permissions.service';
import { Responses } from '../interfaces/responses';
import { LoginService } from '../service/authentication/login.service';
import { User } from '../interfaces/user';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MenuGuard implements CanActivate {
  public user !: User;
  constructor(  private rolesPermissionsService : RolesPermissionsService,
    private loginService: LoginService,
    private router: Router,
    private toastr: ToastrService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const path = route.routeConfig?.path;
      return this.checkModulesPermission(path);
  }


  public checkModulesPermission(path: any): Observable<boolean> {
    const checkPath = path === 'quotation-form' ? 'quotations' : path;
    return this.loginService.verificaAutenticacion().pipe(
      switchMap((resp: any) => {
        this.user = resp.data;
        return this.rolesPermissionsService.getPermissionsByUser( this.user.Id!,  this.user.IdRol);
      }),
      map((resp: any) => {
        const hasPermission = resp.data.some((item: any) => item.modulo.Estado === checkPath);
        if (!hasPermission) {
          this.toastr.warning('El usuario no tiene permiso a ese módulo!');
          this.router.navigate(['/']);
        }
        return hasPermission;
      }),
      catchError((error: any) => {
        console.error('Error: ', error);
        return of(false);
      })
    );
  }

}
